import { authApi } from "@/api/auth";
import { ensureRefreshed } from "@/lib/http";
import { useSessionStore } from "@/stores/session";
import { tokenStore } from "./token-store";

let bootPromise: Promise<void> | null = null;

async function loadSession(): Promise<void> {
  // Page reload drops the in-memory access token — try to restore it.
  if (!tokenStore.getAccess() && tokenStore.getRefresh()) {
    await ensureRefreshed();
  }
  try {
    const user = await authApi.me();
    useSessionStore.getState().setUser({
      id: user.id,
      email: user.email,
      displayName: user.displayName,
      role: user.role,
      perms: user.permissions,
      tenants: user.tenants,
    });
    if (user.tenantId) {
      const s = useSessionStore.getState();
      if (s.tenant === "default") s.setTenant(user.tenantId);
    }
  } catch {
    useSessionStore.getState().setUser(null);
  }
}

/** Resolve once we know whether the user is authenticated. Cached. */
export function ensureSession(): Promise<void> {
  if (useSessionStore.getState().user) return Promise.resolve();
  bootPromise ??= loadSession().finally(() => {
    bootPromise = null;
  });
  return bootPromise;
}

/** Call after a successful sign-in so the guard doesn't re-probe. */
export function markSignedIn(): void {
  bootPromise = null;
}

/** Call on sign-out. */
export function resetSession(): void {
  bootPromise = null;
  tokenStore.clear();
  useSessionStore.getState().setUser(null);
}

export function isAuthenticated(): boolean {
  return useSessionStore.getState().user != null;
}
